import React from 'react'

const MenuBurgerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M2.60156 11.6023V10.4023H13.4016V11.6023H2.60156ZM2.60156 8.60234V7.40234H13.4016V8.60234H2.60156ZM2.60156 5.60234V4.40234H13.4016V5.60234H2.60156Z'
      fill='currentcolor'
    />
  </svg>
)

export default MenuBurgerIcon
